import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import TalentsContent from './TalentsContent'
export default class Talents extends Component {

    

    render() {
        let id = this.props.match.params.id;
        return (
            <div class="wrapper">
                <Navbar />
                <Mainmenu />
                <TalentsContent id={id} />
                <Footer />

            </div>


        )
    }
}
